import { render, staticRenderFns } from "./CadastroFornecedores.vue?vue&type=template&id=6e1d97cc&"
import script from "./CadastroFornecedores.vue?vue&type=script&lang=js&"
export * from "./CadastroFornecedores.vue?vue&type=script&lang=js&"
import style0 from "./CadastroFornecedores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports